import React from 'react';
import { List } from 'antd';
import iconClose from '../../../assets/icon-close.png';

const SelectedLiteratureItem = ({ item, onClose }) => {
    return (
        <List.Item
            className="flex w-full items-center justify-between bg-[#F8FBFF]"
            style={{
                padding: '12px',

                marginBottom: '8px',
            }}
            extra={
                <img
                    key="close"
                    className="h-3 w-3 cursor-pointer"
                    src={iconClose}
                    alt="关闭"
                    onClick={onClose}
                />
            }
        >
            {item.references}
        </List.Item>
    );
};

export default SelectedLiteratureItem;
